/**
 * GeChiUI dependencies
 */
import { SVG, Path } from '@gechiui/primitives';

const pullRight = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M14 6v12h6V6h-6zM4 10h7V8.5H4V10zm0 5.5h7V14H4v1.5z" />
	</SVG>
);

export default pullRight;
